import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getContractRules(params) {
  return request({
    url: URL.partner.getContractRules,
    method: 'get',
    params
  })
}

